module.exports = __webpack_public_path__ + "static/media/generation-secondary.19f43399.jpg";